module.exports = __webpack_public_path__ + "img/facebook.9dfbb9e2.svg";